/** A picture's width in its menu under the right mouse button (D-207): parts of the text's width, or its own. */
export function widthItems(t, now, usable, set) {
  const mm = (p) => Math.max(15, Math.round((usable * p) / 100))
  return [
    ...[25, 50, 75, 100].map((p) => ({ label: t('offers.imageWidthOf', { n: p }), hint: `${mm(p)} mm`, on: Number(now) === mm(p), action: () => set(mm(p)) })),
    { divider: true },
    { label: t('offers.imageWidthAuto'), icon: 'fa-expand', on: !now, action: () => set(null) },
  ]
}
